import { DatePipe } from '@angular/common';
import { InfoUtil } from './info-util';
import { style } from '@angular/animations';
import { escapeRegExp } from 'tslint/lib/utils';
import { QueryList, ElementRef } from '@angular/core';
import * as FileSaver from 'file-saver';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

export class Utils {

  static convertStringToDate(dateString: string): Date {

    if (!dateString) {
      return null;
    }

    const day: number = parseInt(dateString.substr(0, 2), 10);
    const month: number = parseInt(dateString.substr(3, 2), 10) - 1;
    const year: number = parseInt(dateString.substr(6, 4), 10);

    if (year === 0 && month === 0 && day === 0) {
      return null;
    }

    if (dateString.length === 10) {
      return new Date(year, month, day);
    }

    const hour: number = parseInt(dateString.substr(11, 2), 10);
    const minute: number = parseInt(dateString.substr(14, 2), 10);
    const second: number = parseInt(dateString.substr(17, 2), 10);

    return new Date(year, month, day, hour, minute, second);

  }
  static removeMascaraCep(value: string): string {
    return value.toString().replace('-', '');
  }

  static onlyNumbers(event){
    const valor = event.key;
    const numeros = /^[0-9]+$/;
    if (!numeros.test(valor) && event.key.length == 1){
      event.preventDefault();
    }
  }

  static removeMascaraTelefone(value: string): string {
    return value.toString().replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
  }
  static formatarNumeroSemDDD(value: string) {
    let retorno = '';
    const numero = Utils.removeMascaraTelefone(value);
    if (numero.length >= 5 && numero.length < 9) {
      retorno = numero.substring(0, 4) + '-' + numero.substring(4);
    } else if (numero.length >= 9) {
      retorno = numero.substring(0, 5) + '-' + numero.substring(5, 9);
    } else {
      retorno = value;
    }
    return retorno;
  }

  static formatarNumeroNew(value: string) {
    let retorno = '';
    let numero = Utils.removeMascaraTelefone(value);
    if (numero.length >= 5 &&  numero.length < 9) {
      retorno = numero.substring(0, 4) + '-' + numero.substring(4);
    } else if (numero.length === 9) {
      retorno = numero.substring(0, 5) + '-' + numero.substring(5);
    } else if (numero.length === 10) {
      retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 6) + '-' + numero.substring(6);
    } else if (numero.length === 11) {
      retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 7) + '-' + numero.substring(7);
    } else {
      retorno = value;
    }
    return retorno;
  }

  static formatarNumero(value: string) {
    let retorno = '';
    const numero = Utils.removeMascaraTelefone(value);
    if (numero.length === 1) {
      retorno = '(' + numero;
    } else if (numero.length === 3) {
      retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2);
    } else if (numero.charAt(2) === '9') {
      retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 7) + '-' + numero.substring(7, 11);
    } else if (numero.charAt(2) !== '9') {
      retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 6) + '-' + numero.substring(6, 10);
    }
    return retorno;
  }

  // static formatarNumero(value: string) {
  //   let retorno = '';
  //   let numero = Utils.removeMascaraTelefone(value);
  //   if (numero.length === 1) {
  //     retorno = '(' + numero;
  //   } else if (numero.length > 1 && numero.length <= 3) {
  //     retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2);
  //   } else if (numero.length > 3 && numero.length <= 7) {
  //     retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 6) + '-' + numero.substring(6);
  //   } else if (numero.length > 7 && numero.length < 10) {
  //     retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 6) + '-' + numero.substring(6, 11);
  //   } else if (numero.length >= 10) {
  //     retorno = '(' + numero.substring(0, 2) + ') ' + numero.substring(2, 7) + '-' + numero.substring(7, 11);
  //   } else {
  //     retorno = value;
  //   }
  //   return retorno;
  // }

  static stringToNumber(value: string) {
    let convrt = parseInt(value, 10);
    if (isNaN(convrt)) {
      convrt = null;
    }
    return convrt;
  }

  static listFinder(lista: any[], filtro: any, property: string): any {
    if (filtro !== undefined && filtro != null && typeof filtro === 'string') {
      filtro = filtro.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    }
    if (lista == null) {
      return null;
    }
    let result: any;
    lista.forEach(elem => {
      let valor = elem[property];
      if(valor !== undefined && valor != null && typeof valor === 'string') {
        valor = valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
      }
      if (valor== filtro) {
        result = elem;
        return;
      }
    });
    return result;
  }


 /*
 * Função para comparar ignorando acentos tanto de origem quanto do retorno dos valores das listas nos elementos com a prop.
 */
  static listFinderWithAccentList(lista: any[], filtro: any, property: string): any {
    if (filtro !== undefined && filtro != null && typeof filtro === 'string') {
      filtro = filtro.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    }
    if (lista == null) {
      return null;
    }
    let result: any;
    let elemListNormalized: any;
    lista.forEach(elem => {
      if (elem[property] !== undefined && elem[property] != null && typeof elem[property] === 'string') {
        elemListNormalized = elem[property].normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
      }
      if (elemListNormalized == filtro) {
        result = elem;
        return;
      }
    });
    return result;
  }


  static stringToNumberFloat(value: string) {
    let convrt = parseFloat(value);
    if (isNaN(convrt)) {
      convrt = null;
    }
    return convrt;
  }

  static changeFocus(objetoRef: any) {
    try {
      return objetoRef.nativeElement.focus();
    } catch (e) {
      try {
        return (objetoRef as QueryList<ElementRef>).first.nativeElement.focus();
      } catch (e) {
        //   console.log('Não foi possível dar focus no objeto ' + objetoRef);
      }
    }
  }

  static mudarCorGrowlPrioridade(cor, id) {
    let x = document.querySelectorAll('.ui-growl-item-container:last-child');
    let a = <HTMLScriptElement>x[0];
    a.style.backgroundColor = cor;
    // document.getElementById(id).style.backgroundColor = cor;
  }


  static addParam(parametro: string, value: any, url: string): string {


    if (!value) {
      return url;
    }

    if (url.indexOf('?') > -1) {
      url += '&';
    } else {
      url += '?';
    }

    if (typeof (value) === 'string') {
      value = value.toUpperCase();
    } else if (value != null) {
      value = value.toString().toUpperCase();
    } else {
      return url;
    }

    url += parametro + '=' + escapeRegExp(value.toUpperCase());

    return url;

  }

  static addParamURI(parametro: string, value: any, url: string): string {


    if (!value) {
      return url;
    }

    if (url.indexOf('?') > -1) {
      url += '&';
    } else {
      url += '?';
    }

    if (typeof (value) === 'string') {
      value = value.toUpperCase();
    } else if (value != null) {
      value = value.toString().toUpperCase();
    } else {
      return url;
    }

    url += parametro + '=' + encodeURIComponent(value.toUpperCase());

    return url;

  }

  static listaSexo() {
    return [
      { dsSexo: 'F', value: 'F', label: 'Feminino' },
      { dsSexo: 'M', value: 'M', label: 'Masculino' }
    ];
  }

  static formataData(dataAtual: Date): string {
    let newDate = new DatePipe('pt-BR').transform(dataAtual, 'dd/MM/yyyy HH:mm:ss');
    return newDate;
    // let dia: String;
    // let mes: String;
    // let hora: String;
    // let minuto: String;
    // let segundo: String;

    // dia = dataAtual.getDate() < 10 ? '0' + dataAtual.getDate().toString() : dataAtual.getDate().toString();
    // mes = (dataAtual.getMonth() + 1) < 10 ? '0' + (dataAtual.getMonth() + 1).toString() : (dataAtual.getMonth() + 1).toString();
    // hora = dataAtual.getHours() < 10 ? '0' + dataAtual.getHours().toString() : dataAtual.getHours().toString();
    // minuto = dataAtual.getMinutes() < 10 ? '0' + dataAtual.getMinutes().toString() : dataAtual.getMinutes().toString();
    // segundo = dataAtual.getSeconds() < 10 ? '0' + dataAtual.getSeconds().toString() : dataAtual.getSeconds().toString();

    // return dia + '/' + mes + '/' + dataAtual.getFullYear().toString() + ' ' + hora + ':' + minuto + ':' + segundo;
  }

  static formataDataSemHrMi(dia: string, mes: string, ano: string): string {
    if (dia && dia != null) {
      return dia + '/' + mes + '/' + ano;
    }

    return '';

  }

  static quebraStringData(idField: any): any {
    if (idField && idField != null) {
      const listaData = idField.split('-');
      return listaData;
    }
    return null;
  }

  static formataDataCompletaString(dia: string, mes: string, ano: string, hora: string, minuto: string, segundo: string): string {
    return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + minuto + ':' + segundo;
  }

  static localizacaoCalendario() {
    const ptbr = {
      firstDayOfWeek: 0,
      dayNames: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado'
      ],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      monthNamesShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
      ],
      today: 'Hoje',
      clear: 'Apagar'
    };
    return ptbr;
  }

  static isEmptyObject(obj) { // retorna TRUE se o objeto estiver vazio
    if (!obj) {
      return true;
    }
    return !Object.keys(obj).length;
  }


  static formataDataSemHr(dataAtual: Date): string {
    let dia: String;
    let mes: String;
    dia = dataAtual.getDate() < 10 ? '0' + dataAtual.getDate().toString() : dataAtual.getDate().toString();
    mes = (dataAtual.getMonth() + 1) < 10 ? '0' + (dataAtual.getMonth() + 1).toString() : (dataAtual.getMonth() + 1).toString();
    return dia + '/' + mes + '/' + dataAtual.getFullYear().toString();

  }

  static dataNascimentoCalc(data: Date): any {
    if (data == null) {
      return { 'idIdade': 0, 'cdTipoIdade': 3 };
    }
    const dataAtual: Date = new Date(InfoUtil.sysdate);
    const dataNascimento: Date = new Date(data);
    let idIdade: number;
    let cdTipoIdade: number;

    const result: number = (dataAtual.getTime() - dataNascimento.getTime()) / 24 * 60 * 60 * 1000;

    if (result <= 45) {

      idIdade = result;
      cdTipoIdade = 3;

    } else if (result > 45) {

      const ano: number = dataAtual.getFullYear() - dataNascimento.getFullYear();
      let mes: number = dataAtual.getMonth() - dataNascimento.getMonth();
      const dia: number = dataAtual.getDate() - dataNascimento.getDate();

      if (ano <= 1) {
        mes = ano * 12 + mes;
        if (mes === 12) {
          idIdade = 1;
          cdTipoIdade = 1;
        } else {
          idIdade = mes;
          cdTipoIdade = 2;
        }
      } else {
        idIdade = ano + (mes < 0 ? -1 : ((dia < 0 && mes === 0) ? -1 : 0));
        cdTipoIdade = 1;
      }
    }

    return { 'idIdade': idIdade, 'cdTipoIdade': cdTipoIdade };

  }

  static formataHora(dataAtual: Date): string {
    let hora: String;
    let minuto: String;
    let segundo: String;

    hora = dataAtual.getHours() < 10 ? '0' + dataAtual.getHours().toString() : dataAtual.getHours().toString();
    minuto = dataAtual.getMinutes() < 10 ? '0' + dataAtual.getMinutes().toString() : dataAtual.getMinutes().toString();
    segundo = dataAtual.getSeconds() < 10 ? '0' + dataAtual.getSeconds().toString() : dataAtual.getSeconds().toString();

    return hora + ':' + minuto + ':' + segundo;
  }


  static retirarCaracteresEspeciais(texto: string): string {
    if (texto != null) {
      // acento agudo
      texto = texto.replace('á', 'a');
      texto = texto.replace('é', 'e');
      texto = texto.replace('í', 'i');
      texto = texto.replace('ó', 'o');
      texto = texto.replace('ú', 'u');
      texto = texto.replace('ý', 'y');
      texto = texto.replace('Á', 'A');
      texto = texto.replace('É', 'E');
      texto = texto.replace('Í', 'I');
      texto = texto.replace('Ó', 'O');
      texto = texto.replace('Ú', 'U');
      texto = texto.replace('Ý', 'Y');
      texto = texto.replace('´', '');

      // acento circunflexo
      texto = texto.replace('â', 'a');
      texto = texto.replace('ê', 'e');
      texto = texto.replace('î', 'i');
      texto = texto.replace('ô', 'o');
      texto = texto.replace('û', 'u');
      texto = texto.replace('Â', 'A');
      texto = texto.replace('Ê', 'E');
      texto = texto.replace('Î', 'I');
      texto = texto.replace('Ô', 'O');
      texto = texto.replace('Û', 'U');
      texto = texto.replace('^', '');

      // til
      texto = texto.replace('ã', 'a');
      texto = texto.replace('õ', 'o');
      texto = texto.replace('Ã', 'A');
      texto = texto.replace('Õ', 'O');
      texto = texto.replace('~', '');

      // ce-cedilha
      texto = texto.replace('ç', 'c');
      texto = texto.replace('Ç', 'C');

      // trema
      texto = texto.replace('ï', 'i');
      texto = texto.replace('Ï', 'I');
      texto = texto.replace('ü', 'u');
      texto = texto.replace('Ü', 'U');
      texto = texto.replace('¨', '');

      // crase
      texto = texto.replace('à', 'a');
      texto = texto.replace('è', 'e');
      texto = texto.replace('ì', 'i');
      texto = texto.replace('ò', 'o');
      texto = texto.replace('ù', 'u');
      texto = texto.replace('À', 'A');
      texto = texto.replace('È', 'E');
      texto = texto.replace('Ì', 'I');
      texto = texto.replace('Ò', 'O');
      texto = texto.replace('Ù', 'U');
      texto = texto.replace('`', '');
    }
    return texto;
  }


  static formataDataTipe(dataAtual: Date): string {
    let newDate = new DatePipe('pt-BR').transform(dataAtual, 'dd/MM/yyyy HH:mm:ss', '-0300');
    return newDate;
  }

  static formataDataTipeSemHr(dataAtual: Date): string {
    const newDate = new DatePipe('pt-BR').transform(dataAtual, 'dd/MM/yyyy', '-0300');
    return newDate;
  }

  static formataDataTipeHora(dataAtual: Date): string {
    const newDate = new DatePipe('pt-BR').transform(dataAtual, 'HH:mm:ss', '-0300');
    return newDate;
  }

  static formatarCpf(value: string) {
    let retorno = value;
    const numero = Utils.removeMascaraCpf(value);
    if (numero.length === 3) {
      retorno = numero + '.';
    } else if (numero.length === 6) {
      retorno = numero.substring(0, 3) + '.' + numero.substring(3, 6) + '.';
    } else if (numero.length > 6) {
      retorno = numero.substring(0, 3) + '.' + numero.substring(3, 6) + '.' + numero.substring(6, 9) + '-' + numero.substring(9, 11);
    }
    return retorno;
  }

  static removeMascaraCpf(value: string): string {
    if (value != null) {
      value = value.replace(/\.|-/g, '');
    }
    return value;
  }

  static formatarEdocs(value: string) {
    let retorno = value;
    const numero = Utils.removeMascaraEdocs(value);
    if (numero.length === 4) {
      retorno = numero + '-';
    } else if (numero.length >= 4){
      retorno = numero.substring(0,4) + '-' + numero.substring(4,numero.length);
    }
    return retorno;
  }

  static removeMascaraEdocs(value: string): string {
    if (value != null) {
      value = value.replace(/\.|-/g, '');
    }
    return value;
  }

  static formatarValorEmReal(value: string) {
    let retorno = value;
    const numero = Utils.removeMascaraFormatarValorEmReal(retorno);
    if (numero.length === 2) {
      retorno = 'R$ ' + numero + ',';
    } else if (numero.length >= 3){
      retorno = numero.substring(0,numero.length-2) + ',' + numero.substring(numero.length-2,numero.length);
    }
    return retorno;
  }

  static removeMascaraFormatarValorEmReal(value: string): string {
    if (value != null) {
      value = value.replace(/\.|,-R$/g, '');
    }
    return value;
  }

  // Converte um tipo Date para string no formato dd/mm/yyyy HH:mm:ss
  static dataFormatada(data: Date): string {
    const dia = data.getDate().toString();
    const diaF = (dia.length === 1) ? '0' + dia : dia;
    const mes = (data.getMonth() + 1).toString(); // +1 pois no getMonth Janeiro começa com zero.
    const mesF = (mes.length === 1) ? '0' + mes : mes;
    const anoF = data.getFullYear();
    const hora = data.getHours().toString();
    const horaF = (hora.length === 1) ? '0' + hora : hora;
    const min = data.getMinutes().toString();
    const minF = (min.length === 1) ? '0' + min : min;
    const sec = data.getSeconds().toString();
    const secF = (sec.length === 1) ? '0' + sec : sec;
    return diaF + '/' + mesF + '/' + anoF + ' ' + horaF + ':' + minF + ':' + secF;
  }

  static testaNumero(event) {
    if (('0123456789'.indexOf(event.key) === -1 && event.key.toUpperCase() !== 'TAB'
      && event.key.toUpperCase() !== 'BACKSPACE') || event.key.toUpperCase() === 'DEAD') {
      event.preventDefault();
    }
  }

  static getDate(input): Date {
    if (Object.prototype.toString.call(input) === '[object Date]') {
      return input;
    }
    return new Date(input);
  }

  static download(file, documentName, contentType) {
    const myFile = this.base64ToFile(file, documentName, contentType);
    FileSaver.saveAs(myFile, documentName);
  }

  static base64ToFile(base64Data, tempfilename, contentType) {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new File(byteArrays, tempfilename, { type: contentType });
  }

  static validaEmail(value: string) {
    const re = /\S+@\S+\.\S+/;
    if (value) {
      const emailValido = re.test(value);
      return emailValido;
    } else {
      return true;
    }
  }

  static validarCnpj(value: string){
    const re = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
    if(value){
      const cnpjValido = re.test(value);
      return cnpjValido;
    }else{
      return true;
    }
  }

  static validarTelefone(value: string){

    if(value){
      const numero = Utils.removeMascaraTelefone(value);
      const telefoneValido = (numero.length > 9);
      return telefoneValido;
    }else{
      return true;
    }
  }

  static formatarCep(value) {
    let retorno = value;
    const numero = Utils.removeMascaraCep(value);
    if (numero.length === 5) {
      retorno = numero + '-' + numero.substring(5, 8);
    } else if (numero.length === 8) {
      retorno = numero.substring(0, 5) + '-' + numero.substring(5, 8);
    }
    return retorno;
  }

  static formatToReport(date) {
    let day: string = date.getDate().toString();
    day = day.length === 1 ? this.substitute('0{0}', day) : day;

    const monthNumber: number = date.getMonth() + 1;
    let month: string = monthNumber.toString();
    month = month.length === 1 ? this.substitute('0{0}', month) : month;

    const year: string = date.getFullYear().toString();

    return this.substitute('{0}{1}{2}', day, month, year);
  }

  static formatToReportDateHora(date) {
    let day: string = date.getDate().toString();
    day = day.length === 1 ? this.substitute('0{0}', day) : day;

    const monthNumber: number = date.getMonth() + 1;
    let month: string = monthNumber.toString();
    month = month.length === 1 ? this.substitute('0{0}', month) : month;

    const year: string = date.getFullYear().toString();

    let timeH: string = date.getHours().toString();
    timeH = timeH.length === 1 ? this.substitute('0{0}', timeH) : timeH;

    let timeM: string = date.getMinutes().toString();
    timeM = timeM.length === 1 ? this.substitute('0{0}', timeM) : timeM;

    const time = timeH + timeM;

    return this.substitute('{0}{1}{2}{3}', day, month, year, time);
  }

  static substitute(str: string, ... rest): string {
    if (str == null) {
      return '';
    }

    let len: number = rest.length;
    let args: any[];
    if (len === 1 && rest[0] != null && rest[0].length > 0) {
      args = rest[0];
      len = args.length;
    } else {
      args = rest;
    }

    for (let i = 0; i < len; i++) {
          str = str.replace(new RegExp('\\{' + i + '\\}', 'g'), args[i]);
    }

   return str;
  }

  static formataCnpj(value) {
    let retorno = value;
    const numero = value.replace(/\D/g, '');
    if (numero.length === 2) {
      retorno = numero + '.';
    } else if (numero.length === 5) {
      retorno = numero.substring(0, 2) + '.' + numero.substring(2, 5) + '.';
    } else if (numero.length === 12) {
      retorno = numero.substring(0, 2) + '.' + numero.substring(2, 5) + '.' + numero.substring(5, 8) + '/' + numero.substring(8, 12);
    } else if (numero.length > 12) {
      retorno = numero.substring(0, 2) + '.' + numero.substring(2, 5) + '.' + numero.substring(5, 8) + '/' + numero.substring(8, 12) + '-' + numero.substring(12, 14);
    }
    return retorno;
  }

  static mascaraBRL(event) {
    let valor = parseInt(event.toString().replace(/\D/g, ''));
    valor = valor / 100;
    let newVal = new CurrencyPipe('pt-BR').transform(valor, 'BRL');
    if (newVal) {
      return newVal;
    }
    return '';
  }

  static mascaraInteiro(event) {
    let valor = parseInt(event.target.value.toString().replace(/\D/g, ''));
    let newVal = new DecimalPipe('pt-BR').transform(valor, "1.0-0");
    if (newVal) {
      return newVal;
    }
    return '';
  }

  static formatarNota(event) {
    let valor = parseInt(event.toString().replace(/\D/g, ''));
    valor = valor / 100;
    if (valor) {
      return valor;
    }
    return 0;
  }

  static checkRepeatedValueInList(lista, propertyValue: string, value, propertyPK: string, primaryKey) {
    if (value) {
      for (let i = 0; i < lista.length; i++) {
        if (lista[i][propertyValue] && lista[i][propertyValue].trim().toUpperCase() === value.trim().toUpperCase()
          && (!primaryKey || lista[i][propertyPK] !== primaryKey)) {
          return true;
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/utils.ts